import { Download, SlidersHorizontal } from "lucide-react";

const GROUP_OPTIONS = [
  { value: "alumno", label: "Alumno" },
  { value: "pregunta", label: "Pregunta" },
];

export default function ActivityReportToolbar({
  groupBy,
  onGroupByChange,
  hideEmpty,
  onHideEmptyChange,
  counts,
  canDownload,
  downloading,
  onDownload,
  onEditSelection,
}) {
  return (
    <div className="bg-white rounded-xl border border-gray-200 px-4 py-3 flex flex-wrap items-center gap-4">
      <div className="flex items-center gap-2">
        <span className="text-sm text-gray-500">Agrupar por:</span>
        <div className="flex bg-gray-100 rounded-lg p-0.5">
          {GROUP_OPTIONS.map((option) => (
            <button
              key={option.value}
              onClick={() => onGroupByChange(option.value)}
              className={`px-3 py-1.5 text-sm font-medium rounded-md transition-colors ${
                groupBy === option.value
                  ? "bg-white text-indigo-600 shadow-sm"
                  : "text-gray-500 hover:text-gray-700"
              }`}
            >
              {option.label}
            </button>
          ))}
        </div>
      </div>

      <label className="flex items-center gap-2 cursor-pointer">
        <input
          type="checkbox"
          checked={hideEmpty}
          onChange={(event) => onHideEmptyChange(event.target.checked)}
          className="w-4 h-4 accent-indigo-600"
        />
        <span className="text-sm text-gray-700">Ocultar sin respuesta</span>
      </label>

      <span className="text-sm text-gray-500">
        <span className="font-medium text-gray-900">{counts.answered}</span> con
        respuesta ·{" "}
        <span className="font-medium text-gray-900">{counts.missing}</span> sin
        responder
      </span>

      <div className="ml-auto flex items-center gap-2">
        <button
          onClick={onEditSelection}
          className="flex items-center gap-2 px-3 py-2 text-sm font-medium text-gray-700 border border-gray-200 rounded-lg hover:bg-gray-50 transition-colors"
        >
          <SlidersHorizontal size={16} />
          Editar selección
        </button>

        <button
          onClick={onDownload}
          disabled={!canDownload}
          className="flex items-center gap-2 px-4 py-2 bg-indigo-600 text-white text-sm font-medium rounded-lg hover:bg-indigo-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
        >
          <Download size={16} />
          {downloading ? "Generando…" : "Descargar PDF"}
        </button>
      </div>
    </div>
  );
}
